<template>
  <div class="container">
    <!-- <div class="is-pulled-right">
      <b-button type="is-normal" class="voucherbutton" @click="showVoucherDialog">Voucher gebruiken</b-button>
    </div> -->

    <div class="columns">
      <div class="column is-one-third">
        <div class="card" :class="{ 'selected': (subscriptionType == 'standaard') }">
          <h3 class="title is-4 has-text-centered">Standaard</h3>
          <figure class="has-text-centered">
            <img class="logo-img" src="../../assets/undraw/standard.svg" />
          </figure>
          <ul class="ul-content">
            <li><b-icon icon="check" size="is-small" class="mr-2" />3 Woordenlijsten scannen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />5 Wiskunde vragen</li>
            <li class="grayed-out"><b-icon icon="close" size="is-small" class="mr-2" />Woordjes achteraf goedrekenen</li>
            <li class="grayed-out"><b-icon icon="close" size="is-small" class="mr-2" />Woordenlijsten samenvoegen</li>
            <li class="grayed-out"><b-icon icon="close" size="is-small" class="mr-2" />Uitgebreide overhoortijd</li>
            <li class="grayed-out"><b-icon icon="close" size="is-small" class="mr-2" />Met Enter naar volgende woord</li>
            <li class="grayed-out"><b-icon icon="close" size="is-small" class="mr-2" />Herstellen uit prullenbak</li>
            <li class="grayed-out"><b-icon icon="close" size="is-small" class="mr-2" />Aantal vragen instellen</li>
            <li class="grayed-out"><b-icon icon="close" size="is-small" class="mr-2" />Voorbeeldzinnen</li>
          </ul>
        </div>
      </div>
      <div class="column is-one-third">
        <div class="card" :class="{ 'selected': (subscriptionType == 'plus') }">
          <h3 class="title is-4 has-text-centered">Plus</h3>
          <figure class="has-text-centered">
            <img class="logo-img" src="../../assets/undraw/plus.svg" />
          </figure>
          <ul class="ul-content">
            <li><b-icon icon="check" size="is-small" class="mr-2" />20 Woordenlijsten scannen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />50 Wiskunde vragen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Woordjes achteraf goedrekenen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Woordenlijsten samenvoegen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Uitgebreide overhoortijd</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Met Enter naar volgende woord</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Herstellen uit prullenbak</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Aantal vragen instellen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Voorbeeldzinnen</li>
            <li><b-icon icon="pine-tree" size="is-small" class="mr-2" />Er wordt 1 boom geplant</li>
          </ul>
          <h3 class="title is-4 has-text-centered">€ 2,99 /maand</h3>
          <b-button v-if="oldPremium && !hasPremium" @click="buy('plus')" size="is-small" class="is-primary is-centered">Selecteren</b-button>
          <b-button v-if="!oldPremium && !hasPremium" @click="buy('plus')" size="is-small" class="is-primary is-centered">Gratis 7 dagen proberen</b-button>
          <b-button v-if="subscriptionType == 'plus' && hasPremium" @click="confirmCancel()" size="is-small" class="is-danger is-centered" outlined>Annuleren</b-button>
        </div>
      </div>
      <div class="column is-one-third">
        <div class="card" :class="{ 'selected': (subscriptionType == 'pro') }">
          <div class="sale">-50%</div>
          <h3 class="title is-4 has-text-centered">Pro</h3>
          <figure class="has-text-centered">
            <img class="logo-img" src="../../assets/undraw/pro.svg" />
          </figure>
          <ul class="ul-content">
            <li>
              <b-icon icon="check" size="is-small" class="mr-2" />
              <strong>Onbeperkt</strong> woordenlijsten scannen
            </li>
            <li>
              <b-icon icon="check" size="is-small" class="mr-2" />
              <strong>Onbeperkt</strong> wiskunde vragen
            </li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Woordjes achteraf goedrekenen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Woordenlijsten samenvoegen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Uitgebreide overhoortijd</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Met Enter naar volgende woord</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Herstellen uit prullenbak</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Aantal vragen instellen</li>
            <li><b-icon icon="check" size="is-small" class="mr-2" />Voorbeeldzinnen</li>
            <li><b-icon icon="pine-tree" size="is-small" class="mr-2" />Er worden 2 bomen geplant</li>
          </ul>
          <h3 class="title is-4 has-text-centered">€ 11,99 /jaar</h3>
          <b-button v-if="oldPremium && !hasPremium" @click="buy('pro')" size="is-small" class="is-primary is-centered">Selecteren</b-button>
          <b-button v-if="!oldPremium && !hasPremium" @click="buy('pro')" size="is-small" class="is-primary is-centered">Gratis 7 dagen proberen</b-button>
          <b-button v-if="subscriptionType == 'pro' && hasPremium" @click="confirmCancel()" size="is-small" class="is-danger is-centered" outlined>Annuleren</b-button>
        </div>
      </div>
    </div>
    <!-- <div v-else>
      <h3 class="title is-3 has-text-centered">Jij geniet van deze opties</h3>
      <div class="column is-one-third is-offset-one-third">
        <ul>
          <li><b-icon icon="check"/>Woordjes achteraf goedrekenen</li>
          <li><b-icon icon="check"/>Woordenlijsten samenvoegen</li>
          <li><b-icon icon="check"/>Uitgebreide overhoortijd</li>
          <li><b-icon icon="check"/>Met Enter naar volgende woord</li>
          <li><b-icon icon="check"/>Herstellen uit prullenbak</li>
          <li><b-icon icon="check"/>Aantal vragen instellen</li>
          <li><b-icon icon="check"/>Toegang tot toekomstige opties</li>
        </ul>
      </div>
      <div class="has-text-centered">
        <b-button @click="confirmCancel" type="is-danger">Opzeggen</b-button>
      </div>
    </div> -->
  </div>
</template>
<script>
import ApiService from "../common/api.service"
import { EventBus } from "../common/event-bus"

export default {
  data() {
    return {
      subscriptionType: "standaard",
    }
  },
  mounted() {
    this.getSubscription()
  },
  methods: {
    async getSubscription() {
      let response = await ApiService.get("/user/premium")
      if (response.data.subscriptionType) {
        this.subscriptionType = response.data.subscriptionType
      }
    },
    async buy(type) {
      let response = await ApiService.post("payment", { type })
      window.location = response.data._links.checkout.href
    },
    async confirmCancel() {
      this.$buefy.dialog.confirm({
        title: "Abonnement opzeggen",
        message: "Weet je zeker dat je het abonnement wil opzeggen?",
        confirmText: "Opzeggen",
        type: "is-danger",
        customClass: "dark",
        onConfirm: () => this.cancel(),
      })
    },
    async cancel() {
      let response = await ApiService.post("payment/cancel")
      this.$buefy.toast.open({
        message: "Je abonnement is opgezegd",
        type: "is-success",
      })
    },
    showVoucherDialog() {
      this.$buefy.dialog.prompt({
        message: "Vul hier een vouchercode in",
        inputAttrs: {
          placeholder: "code",
        },
        trapFocus: true,
        confirmText: "Gebruiken",
        onConfirm: (value) => this.useVoucher(value),
      })
    },
    async useVoucher(code) {
      let response = await ApiService.post("payment/voucher", { code })
      if (response.data.error == "not-found") {
        return this.$buefy.toast.open({
          message: "Dat is geen geldige code",
          type: "is-danger",
        })
      } else if (response.data.error == "has-premium") {
        return this.$buefy.toast.open({
          message: "Je hebt momenteel al een premium account",
          type: "is-danger",
        })
      } else {
        this.subscriptionType = "plus"
        return this.$buefy.toast.open({
          message: "Je premium account is geactiveerd",
          type: "is-success",
        })
      }
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state["user"].loggedIn
    },
    oldPremium() {
      return this.$store.state["user"].oldPremium
    },
    hasPremium() {
      return this.$store.state.user.hasPremium
    },
  },
}
</script>
<style scoped lang="scss">
.voucherbutton {
  margin-bottom: 10px;
}
.container {
  padding-top: 20px;
}
.card {
  background: white;
  box-shadow: none;
  border-radius: 20px;
  padding: 20px 15px;
  font-size: 0.9rem;
  &.selected {
    border: 3px solid #4189f4;
  }
  img {
    max-width: 30%;
  }
  .ul-content {
    padding: 20px 0;
    li {
      margin: 5px 0;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.sale {
  display: flex;
  border-radius: 100%;
  background: #ff5b5b;
  color: #fff;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>
